"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisibilityContext = exports.LoginButtonPosition = exports.ENDPOINTS = exports.DEFAULT_HEADER_HEIGHT = exports.MOBILE_HEADER_HEIGHT = exports.MAX_DISPLAYED_HOME_MODULES = exports.MAX_SALES_ITEMS_PER_LIST = exports.MAX_CATERGORY_ITEMS_PER_LIST = exports.MAX_DISPLAYED_CATEGORIES = exports.LATERAL_MENU_ICON_MAPPING = void 0;
exports.LATERAL_MENU_ICON_MAPPING = {
    nav_acc: 'AccountMan',
    nav_alert: 'Communication',
    nav_le_club: 'ContactUs',
    nav_cmd: 'Orders',
    nav_forum: 'ContactUs',
    nav_hlp: 'Help',
    nav_hme: 'Home',
    nav_kdo: 'Gift',
    nav_mob: 'Apps',
    nav_new: 'new',
    nav_off: 'Disconnection',
    nav_spn: 'SponsorshipEuro',
    nav_spn_uk: 'SponsorshipLivre',
};
exports.MAX_DISPLAYED_CATEGORIES = 8;
exports.MAX_CATERGORY_ITEMS_PER_LIST = 5;
exports.MAX_SALES_ITEMS_PER_LIST = 4;
exports.MAX_DISPLAYED_HOME_MODULES = 7;
exports.MOBILE_HEADER_HEIGHT = 113;
exports.DEFAULT_HEADER_HEIGHT = 145;
exports.ENDPOINTS = {
    getHeaders: '/header',
    getHomeHeaders: '/homes/headers',
};
var LoginButtonPosition;
(function (LoginButtonPosition) {
    LoginButtonPosition["HEADER_MENU"] = "Burger menu";
    LoginButtonPosition["HEADER_CORNER"] = "Top corner";
})(LoginButtonPosition || (exports.LoginButtonPosition = LoginButtonPosition = {}));
var VisibilityContext;
(function (VisibilityContext) {
    VisibilityContext["Classical"] = "CLASSICAL";
    VisibilityContext["SEO"] = "SEO";
})(VisibilityContext || (exports.VisibilityContext = VisibilityContext = {}));
